import { classNames } from 'primereact/utils';
import React from 'react';
import { Footer, Header } from '@/components';
import { Outlet } from 'react-router-dom';

export const Layout = (): React.ReactElement => {
	const layoutBodyClassName = classNames('o-layout__body');

	return (
		<div className="o-layout">
			<Header />
			<div className={layoutBodyClassName}>
				<main className="o-layout__main">
					<Outlet />
				</main>
			</div>
			<Footer />
		</div>
	);
};
